<template>
  <div class="notifications-container">
    <ul
      v-if="lastFiveNotifications.length > 0"
      class="notifications"
    >
      <li
        v-for="(notification, index) in lastFiveNotifications"
        :key="index"
        class="notification"
        :class="[`is-${notification.type}`]"
      >
        <button
          class="delete"
          @click="deleteNotification(notification.dateTime)"
        />
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-html="notification.content" />
      </li>
    </ul>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters, mapMutations } = createNamespacedHelpers('ui');

export default {
  name: 'TheGlobalNotifications',
  computed: mapGetters(['lastFiveNotifications']),
  methods: mapMutations(['deleteNotification']),
};
</script>

<style scoped>
.notifications-container {
  top: 1rem;
  position: fixed;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
}

li.notification {
  position: relative;
  margin-bottom: 1rem;
  z-index: 999;
}


@media screen and (max-width: 768px) {
  li.notification {
    max-width: 350px;
  }
}</style>
